var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcChatSelected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.00213 12.0003C3.00213 6.90336 7.13326 2.77148 12.2293 2.77148C17.3253 2.77148 21.4564 6.90336 21.4564 12.0003C21.4564 17.0972 17.3253 21.2291 12.2293 21.2291H3.00193L3.95833 18.2167C4.08946 17.8037 4.05172 17.3586 3.8958 16.9543C3.19064 15.1259 3.00305 12.9461 3.00213 12.0003Z",
    stroke: "#ffffff",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2294 13.3504C12.975 13.3504 13.5794 12.746 13.5794 12.0004C13.5794 11.2548 12.975 10.6504 12.2294 10.6504C11.4838 10.6504 10.8794 11.2548 10.8794 12.0004C10.8794 12.746 11.4838 13.3504 12.2294 13.3504Z",
    fill: "#ffffff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.90957 13.3504C8.65515 13.3504 9.25957 12.746 9.25957 12.0004C9.25957 11.2548 8.65515 10.6504 7.90957 10.6504C7.16399 10.6504 6.55957 11.2548 6.55957 12.0004C6.55957 12.746 7.16399 13.3504 7.90957 13.3504Z",
    fill: "#ffffff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5487 13.3504C17.2943 13.3504 17.8987 12.746 17.8987 12.0004C17.8987 11.2548 17.2943 10.6504 16.5487 10.6504C15.8031 10.6504 15.1987 11.2548 15.1987 12.0004C15.1987 12.746 15.8031 13.3504 16.5487 13.3504Z",
    fill: "#ffffff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcChatSelected);
export default __webpack_public_path__ + "static/media/ic_chat_selected.7cb6e85a82dab71490bb3bdc75697eba.svg";
export { ForwardRef as ReactComponent };